@if(auftrag(); as auftrag) {
  <soft-page>
    <soft-page-header>
      <soft-picking-order [pickingOrder]="auftrag" [small]="!!config?.showLessInfoInArticleView"></soft-picking-order>
    </soft-page-header>
    @if (bewe(); as bewe) { @if(strategy(); as strategy) {
      <div class="pb-24">
        <div class="soft-overline mt-4">
          {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.ARTIKEL' | translate}}
        </div>
        <div class="soft-card">
          <soft-store-item [bewe]="bewe"></soft-store-item>
        </div>

        @if((strategy?.lagerplatzAuswahl || strategy?.loadLagerplatzVorschlag) &&
          !bewe.offenePaletten?.length) {
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.LAGERPLATZ' | translate}}
          </div>
          <soft-lagerplatz-suche
            [lagerplatz]="$safeNavigationMigration((lagerplatz$ | async)?.lagerplatz)"
            (lagerplatzInhaltChange)="onLagerplatzChange($event)"
            (lagerplatzChange)="onLpChange($event)"
            [changeable]="strategy?.lagerplatzAuswahl ?? false"
            [idbewekomm]="strategy?.loadLagerplatzVorschlag ? bewe.id : null"
            [storageId]="$safeNavigationMigration(auftrag?.lager?.id)"
            [disableScan]="true"
          ></soft-lagerplatz-suche>
          } @if((bewe.offenePaletten?.length || 0) > 0 ){
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.PALETTE' | translate}}
          </div>
          <div class="flex flex-col gap-2">
            @for (pallet of bewe.offenePaletten; track pallet.id; let index = $index) {
              <div
                class="soft-card flex flex-row items-center gap-2 cursor-pointer hover:bg-hover"
                [ngClass]="{'!bg-selected': selectedPalette()?.id === pallet.id}"
                (click)="selectPalette(pallet)"
                >
                <soft-checkbox
                  [checked]="selectedPalette()?.id === pallet.id"
                  [readonly]="true"
                ></soft-checkbox>
                <soft-picking-pallet
                  class="w-full"
                  [number]="index + 1"
                  [pallet]="pallet"
                ></soft-picking-pallet>
              </div>
            }
          </div>
        } @else {
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.MENGE' | translate}}
          </div>
          <soft-mengen-eingabe
            class="mt-1"
            [preventKeyboardEventEmission]="true"
            [disabled]="(disabled$ | async) ?? false"
            [value]="(menge$ | async) ?? 0"
            [einheit]="bewe.artikelMengeOffen.einheit.arteh"
            [maxValue]="(maxMenge$ | async) ?? 0"
            [float]="true"
            (valueChange)="onMengeChange(auftrag.id, bewe.id, $event)"
          ></soft-mengen-eingabe>
        }
      </div>
      <button
        class="fixed left-0 right-0 bottom-0 soft-button primary w-full h-20 mt-16"
        [disabled]="isValid()"
        (click)="onSubmit()"
        >
        {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.SUBMIT' | translate}}
      </button>
      } }
    </soft-page>
  }

  @if (loading$ | async) {
    <soft-blocking-loading-spinner
      class="top-0 right-0"
    ></soft-blocking-loading-spinner>
  }


<ng-template #inventoryHeaderTemplate>
  <div class="bg-warning-500/10 border-warning border w-full p-2 rounded-md">
    <h1 class="text-xl font-semibold">Lagerstand des Artikels ist 0!</h1>
    <span class="text-sm text-light">Bitte bestätigen Sie den Lagerstand oder korrigieren Sie diesen!</span>
  </div>
</ng-template>
